<template>
    <router-view></router-view>
</template>

<script>
import { sendPV } from '@/common/weblog';
import { isIOS } from '@/utils/util';
export default {
    name: 'mobile-app',
    data() {
        return {
            isHide: false,
            isIos: isIOS(),
        };
    },
    async mounted() {
        window.addEventListener('beforeunload', () => {
            const { name, params = {}, query = {} } = this.$route;
            if (name) {
                sendPV('CSC_COLLECT_PAGE', 'leave', {
                    biz_key: params.bizKey || '',
                    page_key: params.pageKey,
                    from_key: query.from || -1,
                });
            }
        });
        if (this.isIos) {
            // 解决Vue在IOS上页面回退不会刷新的问题
            window.addEventListener('pageshow', () => {
                if (this.isHide) {
                    window.location.reload();
                }
            });
            window.addEventListener('pagehide', () => {
                this.isHide = true;
            });
        }
    },
};
</script>
